import { render, staticRenderFns } from "./AlunoNotas.vue?vue&type=template&id=77a4dbaa&scoped=true"
import script from "./AlunoNotas.vue?vue&type=script&lang=js"
export * from "./AlunoNotas.vue?vue&type=script&lang=js"
import style0 from "./AlunoNotas.vue?vue&type=style&index=0&id=77a4dbaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a4dbaa",
  null
  
)

export default component.exports